import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";

export class NotEmptyRule extends Validator<IAttributeData[], IAttributeDataError> {
    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        const validationErrors =
            !errors[RuleType.NotEmptyRule] && model.length === 0
                ? {
                      ...errors,
                      [RuleType.NotEmptyRule]: formatMessage(
                          "No data found. If your file has multiple tabs, please make sure your data is on the first tab."
                      ),
                  }
                : errors;

        return super.validate(model, validationErrors);
    }
}
